export const removeLastSegment = (inputString, separator = '/') => {
    if (inputString == null) {
        return inputString;
    }
    const segments = inputString.split(separator);
    segments.pop();
    return segments.join(separator);
};

export const getLastSegment = (inputString, separator = '/') => {
    if (inputString == null) {
        return inputString;
    }
    const segments = inputString.split(separator);
    return segments[segments.length - 1];
};